import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormUtils from "../../../FormUtils";
import {LeadInstallmentOptions, LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";

const MAX_ERROR = "The amount should be between $1000 to $250,000";

export default class FormFinancialSteps {
    public static header = {
        isHeader: true,
        title: "Financials",
        inputType: InputTypes.none
    };

    public static plaidStep = {
        title: "Connect your bank account",
        subTitle: "Private and secured",
        inputType: InputTypes.button,
        propName: "plaidConnection"
    };

    public static installmentsStep = (isInstallmentSelected: (val: number) => void, selectInstallmentPlan: (val: number) => void, isShortSignUp: boolean) => {
        const instellmentsSteps =  {
            title: "Break it into monthly installments",
            inputType: InputTypes.multipleSelect,
            options: [
                {
                    label: "6" ,
                    isSelected: isInstallmentSelected(LeadInstallmentOptions.Installment6),
                    click: () => selectInstallmentPlan(LeadInstallmentOptions.Installment6)
                },
                {
                    label:  "12",
                    isSelected: isInstallmentSelected(LeadInstallmentOptions.Installment12),
                    click: () => selectInstallmentPlan(LeadInstallmentOptions.Installment12)

                },
                {
                    label: "18",
                    isSelected: isInstallmentSelected(LeadInstallmentOptions.Installment18),
                    click: () => selectInstallmentPlan(LeadInstallmentOptions.Installment18)
                },
                {
                    label: "24",
                    isSelected: isInstallmentSelected(LeadInstallmentOptions.Installment24),
                    click: () => selectInstallmentPlan(LeadInstallmentOptions.Installment24)
                },
                {
                    label: "30",
                    isSelected: isInstallmentSelected(LeadInstallmentOptions.Installment30),
                    click: () => selectInstallmentPlan(LeadInstallmentOptions.Installment30)
                },
                {
                    label: "36",
                    isSelected: isInstallmentSelected(LeadInstallmentOptions.Installment36),
                    click: () => selectInstallmentPlan(LeadInstallmentOptions.Installment36)
                }

            ],
            propName: "installmentPlan"
        }
        return instellmentsSteps;
    };

    public static fundingPurposeStep = (isShortSignUp: boolean,reasonSelectedCB: (val: string) => void, fundReason?: string) => {
        return {
            title: "Funding purpose",
            inputType: InputTypes.dropdown,
            options: FormUtils.renderReasonsArray(),
            propName: "fundReason",
            selectedOption: fundReason ? fundReason : undefined,
            cb: reasonSelectedCB
        }
    }

    public static isDepositPaidStep = (depositSelect:(e: any) => void, selectedOption: number | undefined) => {
        return  {
            title: "Already paid your security deposit?",
            inputType: InputTypes.boolean,
            options: [
                {
                    text: "Yes",
                    cta: depositSelect
                } ,
                {
                    text: "Not yet",
                    cta: depositSelect
                }
            ],
            selectedOption,
            propName: "isDepositPaid"
        }
    };

    public static amountStep = (store: any, planType: string, isLocked: boolean) => {
        return {
            title: planType === LeadPlanType.Loan? "Required amount" : "Your next rent payment",
            inputType: InputTypes.amount,
            shortInput: true,
            propName: "amount",
            errorController: store.rentLoanAmountError,
            errorLabel: !FormUtils.loanAmountBounds(store.formInput.financial.amount)? MAX_ERROR : null,
            isLocked,
            customValidationCheck: FormUtils.loanAmountBounds
        }
    };

    public static depositAmountStep = (isShortSignUp: boolean, planType: string) => {
        return {
            title: planType === LeadPlanType.Deposit? "Required Amount" : "Enter security deposit amount",
            inputType: InputTypes.amount,
            shortInput: true,
            propName: "amount",
            allowSkip: true,
            isLocked:  isShortSignUp
        }
    };

    public static firstStep = (planType: string, store: any, selectDeposit: (val: number) => void, selectedDepositValue: number | undefined, isAmountLocked: boolean) => {
        switch (planType) {
            case LeadPlanType.DepositRent:
            case LeadPlanType.Deposit: return FormFinancialSteps.isDepositPaidStep(selectDeposit, selectedDepositValue);
            case LeadPlanType.Loan:
            case LeadPlanType.Rent: return FormFinancialSteps.amountStep(store, planType, isAmountLocked);
            default: return undefined;
        }
    };

    public static secondStep = (planType: string, isAmountLocked: boolean, isInstallmentSelected: (val: number)=> void, selectInstallmentPlan: (val: number) => void) => {
        switch (planType) {
            case LeadPlanType.DepositRent:
            case LeadPlanType.Deposit: return FormFinancialSteps.depositAmountStep(isAmountLocked, planType);
            case LeadPlanType.Loan:
            case LeadPlanType.Rent: return FormFinancialSteps.installmentsStep(isInstallmentSelected, selectInstallmentPlan, isAmountLocked);
            default: return undefined;
        }
    }

    public static thirdStep = (isShortSignUp: boolean, planType: string, onReasonSelected: (val: string)=> void, fundReason?: string) => {
        switch (planType) {
            case LeadPlanType.Rent:
            case LeadPlanType.DepositRent:
            case LeadPlanType.Deposit: return FormFinancialSteps.plaidStep;
            case LeadPlanType.Loan: return FormFinancialSteps.fundingPurposeStep(isShortSignUp, onReasonSelected, fundReason);
            default: return undefined;
        }
    };

    public static forthStep = (planType: string) => {
        if(planType === LeadPlanType.Loan) {
            return FormFinancialSteps.plaidStep;
        }
        return undefined;
    };
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormFinancial/FinancialSteps.ts